module.exports = __webpack_public_path__ + "img/itomanman_comic15.7a0308b8.jpg";